import { useCallback, useEffect, useMemo, useState } from "react";

import {
	ReservationDetailRefundRequestInputZodSchema,
	type ReservationDetailRefundRequestInputType,
} from "./validation-schema";

import type { SafeParseError } from "zod";

export const useHandleFormState = () => {
	/**
	 * 返金希望金額
	 */
	const [refundPrice, setRefundPrice] = useState<number | undefined>(0);
	/**
	 * 返金希望金額を更新
	 */
	const handleChangeRefundPrice = useCallback((value: number | undefined) => {
		setRefundPrice(value);
	}, []);

	/**
	 * 返金理由
	 */
	const [refundReason, setRefundReason] = useState<string>("");
	/**
	 * 返金理由を更新
	 */
	const handleChangeRefundReason = useCallback((value: string) => {
		setRefundReason(value);
	}, []);

	const [validationErrors, setValidationErrors] = useState<
		SafeParseError<ReservationDetailRefundRequestInputType> | undefined
	>(undefined);
	/**
	 * state の変更を監視し、バリデーションを実行
	 */
	useEffect(() => {
		const zodErrors = ReservationDetailRefundRequestInputZodSchema.safeParse({ refundPrice, refundReason });

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	}, [refundPrice, refundReason]);

	const refundPriceErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.refundPrice?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.refundPrice],
	);
	const refundReasonErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.refundReason?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.refundReason],
	);
	const hasError = useMemo(() => validationErrors !== undefined, [validationErrors]);

	return {
		refundPrice,
		refundPriceErrorMessage,
		refundReason,
		refundReasonErrorMessage,
		hasError,
		//
		handleChangeRefundPrice,
		handleChangeRefundReason,
	};
};
